import { HomeAdminView } from "components/materials/home/HomeAdminView";

export default function Page() {
  return <HomeAdminView />;
}
